<template>
  <div :class="control.class">
    <label
      v-if="control.label"
      :for="control.uuid"
      class="label"
      :style="{ color: control.brand_colour ? '#000000' : undefined }"
    >
      {{ control.label }}
      <span
        v-if="control.rules && control.rules.split('|').includes('required')"
        :style="{ color: control.brand_colour ?? 'rgb(253 1 130 / var(--tw-text-opacity))' }"
      >
        *
      </span>
    </label>

    <span class="relative block">
      <span class="absolute pointer-events-none right-0 inset-y-0 flex items-center justify-center px-4">
        <CalendarFold class="w-4 h-4 opacity-50" />
      </span>
      <input
        v-model="value"
        :name="control.name"
        :id="control.uuid"
        type="date"
        :max="control.max"
        :min="control.min"
        :readonly="control.readonly"
        :placeholder="control.placeholder"
        :aria-label="control.placeholder"
        :disabled="control.disabled"
        autocomplete="off"
        class="appearance-none placeholder-gray-400 py-3 px-4 border border-white/10 bg-white/5 rounded-lg block transition duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-opacity-25 disabled:opacity-50 disabled:cursor-not-allowed focus:border-current w-full"
        :style="control.brand_colour
          ? { backgroundColor: '#f5f5f5' }      /* optional light grey if brand exists */
          : { '--tw-ring-color': 'rgb(253 1 130 / var(--tw-text-opacity))' }"
      />
    </span>

    <Error
      v-if="errorMessage"
      :style="{ color: control.brand_colour ?? 'rgb(253 1 130 / var(--tw-text-opacity))' }"
    >
      {{ errorMessage }}
    </Error>
    <Note v-if="control.note">{{ control.note }}</Note>
  </div>
</template>

<script setup>
import { CalendarFold } from 'lucide-vue-next'
import { useField } from 'vee-validate'

const props = defineProps({
  control: Object
})

const validateYearFormat = (value) => {
  if (!value) return true
  const year = new Date(value).getFullYear()
  if (year < 2024 || year > 9999) {
    return 'Please enter a valid 4-digit year.'
  }
  return true
}

const rules = [props.control.rules, validateYearFormat]

const { value, errorMessage } = useField(
  props.control.name,
  rules,
  { label: props.control.label }
)
</script>

<style>
input[type=date].appearance-none::-webkit-inner-spin-button,
input[type=date].appearance-none::-webkit-calendar-picker-indicator {
  -webkit-appearance: none;
  margin: 0;
}
input[type=date].appearance-none {
  -moz-appearance: textfield;
}
</style>
